module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bg-main"
  }, [_c('div', {
    staticClass: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"
  }, [_c('div', {
    staticClass: "flex justify-between h-16"
  }, [_c('div', {
    staticClass: "w-full flex justify-between"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "hidden md:ml-6 md:flex md:items-center"
  }, _vm._l((_vm.routes), function(route) {
    return _c('router-link', {
      key: route.title,
      staticClass: "menu-item ml-4 px-3 py-2 rounded-md text-sm font-medium leading-5 text-white",
      class: {
        'selected': _vm.$route.name === route.name
      },
      attrs: {
        "tag": "a",
        "href": "#",
        "to": {
          name: route.name
        }
      }
    }, [_vm._v("\n                        " + _vm._s(route.title) + "\n                    ")])
  }), 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-shrink-0 flex items-center"
  }, [_c('img', {
    staticClass: "block lg:hidden h-8 w-auto",
    attrs: {
      "src": "/static/svg/logo.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "hidden lg:block h-8 w-auto",
    attrs: {
      "src": "/static/svg/logo.svg",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5ceab56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/menu.vue
// module id = 295
// module chunks = 1